import React, { useEffect, useState } from 'react';
import classes from './TestList.module.css';
import BrainIcon from '../../icons/BrainIcon';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BackButton } from '../../buttons/BackButton';
 const TestList = ()=> {
   const baseUrl = process.env.REACT_APP_API_URL;

   const navigate  = useNavigate();
   const {id} = useParams();
   const [data, setData] = useState();
   const [isFinished , setIsFinished] = useState(0);


   useEffect(()=>{
      axios.get(baseUrl+"/appi/quiz/tests/"+id).then((response)=>{
         let list = response.data;
         setData( list.filter(it => it.isFinished === isFinished));
         console.log(list );
      })
      .catch((error) => {
         console.error(error);
      })
   },[isFinished])

   const goTo=(e,id,index)=>{
   
      
      console.log(id);
     
      localStorage.setItem("test-quiz-progress",id);
      axios.get(baseUrl+'/appi/quiz/test/'+ id + '/'+ 1, { withCredentials: true })
      .then(response=>{
        localStorage.setItem("test-quiz",JSON.stringify(response.data));
        console.log(response.data);
        navigate('/test');
        
      })
      .catch(error => {

      });
   }


  return (
    <div className={classes.list_view}>
               <div className={classes.header}>
                  <div className={`${classes.btn}  ${classes.not_done} ${(isFinished === 0) ? classes.chosen : '' }`} 
                  onClick={(e) => setIsFinished(0)}>
                     До виконання
                     </div>
                  <div className={`${classes.btn} ${classes.done} ${(isFinished === 1) ? classes.chosen : '' }`} 
                  onClick={(e) => setIsFinished(1)} >
                     Виконані</div>
               </div>
      {
        Array.isArray(data) ?  data?.map( ( el,index )=>
            (
               <div key={index} className={classes.wrapper_element}>
                  <div  className={classes.element} data-elid={el.id} onClick={(e) => goTo(e.target,el.id,index)}>
                     <div className={classes.icon_wrapper}>

                        <BrainIcon className={classes.icon_test} />

                     {/* <svg className={classes.icon_test} xmlns="http://www.w3.org/2000/svg" height="55px" viewBox="0 -960 960 960" width="55px" fill="#75FB4C"><path d="M390-120q-51 0-88-35.5T260-241q-60-8-100-53t-40-106q0-21 5.5-41.5T142-480q-11-18-16.5-38t-5.5-42q0-61 40-105.5t99-52.5q3-51 41-86.5t90-35.5q26 0 48.5 10t41.5 27q18-17 41-27t49-10q52 0 89.5 35t40.5 86q59 8 99.5 53T840-560q0 22-5.5 42T818-480q11 18 16.5 38.5T840-400q0 62-40.5 106.5T699-241q-5 50-41.5 85.5T570-120q-25 0-48.5-9.5T480-156q-19 17-42 26.5t-48 9.5Zm130-590v460q0 21 14.5 35.5T570-200q20 0 34.5-16t15.5-36q-21-8-38.5-21.5T550-306q-10-14-7.5-30t16.5-26q14-10 30-7.5t26 16.5q11 16 28 24.5t37 8.5q33 0 56.5-23.5T760-400q0-5-.5-10t-2.5-10q-17 10-36.5 15t-40.5 5q-17 0-28.5-11.5T640-440q0-17 11.5-28.5T680-480q33 0 56.5-23.5T760-560q0-33-23.5-56T680-640q-11 18-28.5 31.5T613-587q-16 6-31-1t-20-23q-5-16 1.5-31t22.5-20q15-5 24.5-18t9.5-30q0-21-14.5-35.5T570-760q-21 0-35.5 14.5T520-710Zm-80 460v-460q0-21-14.5-35.5T390-760q-21 0-35.5 14.5T340-710q0 16 9 29.5t24 18.5q16 5 23 20t2 31q-6 16-21 23t-31 1q-21-8-38.5-21.5T279-640q-32 1-55.5 24.5T200-560q0 33 23.5 56.5T280-480q17 0 28.5 11.5T320-440q0 17-11.5 28.5T280-400q-21 0-40.5-5T203-420q-2 5-2.5 10t-.5 10q0 33 23.5 56.5T280-320q20 0 37-8.5t28-24.5q10-14 26-16.5t30 7.5q14 10 16.5 26t-7.5 30q-14 19-32 33t-39 22q1 20 16 35.5t35 15.5q21 0 35.5-14.5T440-250Zm40-230Z"/></svg> */}

                        {/* <svg className={classes.icon_test} xmlns="http://www.w3.org/2000/svg" height="55px" viewBox="0 -960 960 960" width="55px" fill={"rgb(143, 207, 247)"}>
                        <path d="M560-360q17 0 29.5-12.5T602-402q0-17-12.5-29.5T560-444q-17 0-29.5 12.5T518-402q0 17 12.5 29.5T560-360Zm-30-128h60q0-29 6-42.5t28-35.5q30-30 40-48.5t10-43.5q0-45-31.5-73.5T560-760q-41 0-71.5 23T446-676l54 22q9-25 24.5-37.5T560-704q24 0 39 13.5t15 36.5q0 14-8 26.5T578-596q-33 29-40.5 45.5T530-488ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Z"/>
                        </svg> */}
                        <p>{el.conversationId.name}</p>
                        {
                           el.isFinished == 1?
                           (<>
                              
                              <svg className={classes.icon_verified } xmlns="http://www.w3.org/2000/svg" height="84px" viewBox="0 -960 960 960" width="84px" fill="#75FB4C"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z"/></svg>
                              <svg className={classes.icon_done } xmlns="http://www.w3.org/2000/svg" height="34px" viewBox="0 -960 960 960" width="34px" 
                              fill="#FFFF55">
                              <path d="M480-160q75 0 127.5-52.5T660-340q0-75-52.5-127.5T480-520q-75 0-127.5 52.5T300-340q0 75 52.5 127.5T480-160ZM363-572q20-11 42.5-17.5T451-598L350-800H250l113 228Zm234 0 114-228H610l-85 170 19 38q14 4 27 8.5t26 11.5ZM256-208q-17-29-26.5-62.5T220-340q0-36 9.5-69.5T256-472q-42 14-69 49.5T160-340q0 47 27 82.5t69 49.5Zm448 0q42-14 69-49.5t27-82.5q0-47-27-82.5T704-472q17 29 26.5 62.5T740-340q0 36-9.5 69.5T704-208ZM480-80q-40 0-76.5-11.5T336-123q-9 2-18 2.5t-19 .5q-91 0-155-64T80-339q0-87 58-149t143-69L120-880h280l80 160 80-160h280L680-559q85 8 142.5 70T880-340q0 92-64 156t-156 64q-9 0-18.5-.5T623-123q-31 20-67 31.5T480-80Zm0-260ZM363-572 250-800l113 228Zm234 0 114-228-114 228ZM406-230l28-91-74-53h91l29-96 29 96h91l-74 53 28 91-74-56-74 56Z"/>
                              </svg>
                           </>
                        
                           ) 
                           : ('')
                        }
                     </div>
                     <div>
                        
                        <p className={classes.description}>{el.conversationId.description}</p>
                     </div>
                  
                  
                  </div>
            </div>
            )
            
         )
         :''
      }
   <BackButton onClick={() => navigate(-1)} />
   </div>
  )
}
export default TestList;